import { render, staticRenderFns } from "./NavEntry.vue?vue&type=template&id=973422b6&scoped=true"
import script from "./NavEntry.vue?vue&type=script&lang=js"
export * from "./NavEntry.vue?vue&type=script&lang=js"
import style0 from "./NavEntry.vue?vue&type=style&index=0&id=973422b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "973422b6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListGroup } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VIcon,VListGroup,VListItem,VListItemContent,VListItemIcon,VListItemTitle})
